import React, { useEffect, useState } from "react";
import styles from "./CheckBoxScoreComponent.module.scss";
import { InputLabel, TextField, Tooltip } from "@mui/material";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { setWeight } from "redux/slices/scoringSlice";
import { useDispatch } from "react-redux";
import { capitalizeFirstLetter, truncateText } from "utils/utils";
import { setPublish } from "redux/slices/globalSlice";
import toast from "react-hot-toast";

const CheckBoxScoreComponent = ({ handleDelete, item, initialValues = {} }) => {
  // State to manage scores for Checked and Not Checked
  // console.log("CheckBoxScoreComponent: ", { options: item?.options });

  const [scores, setScores] = useState({
    checked: item?.options?.[0]?.score || "1",
    unchecked: item?.options?.[1]?.score || "0",
  });

  const dispatch = useDispatch();

  const modifiedOptionsWithWieghtAndmaxWeight = (updatedScores) => {
    const options = Object?.entries(updatedScores)?.reduce((acc, cr) => {
      const [option, score] = cr;
      acc?.push({
        option: capitalizeFirstLetter(option),
        score: Number(score),
      });
      return acc;
    }, []);

    const maxWeight = options.reduce((max, current) => {
      return current.score > max ? current.score : max;
    }, -Infinity);

    return { maxWeight, options };
  };

  // Handle input change for scores
  const handleInputChange = (field, value) => {
    let updatedScores = { ...scores };

    if (!value && value !== 0) {
      toast.error("Please enter only valid numbers");
    }

    updatedScores = { ...scores, [field]: value };

    setScores(updatedScores);
    dispatch(setPublish(true));

    const { options, maxWeight } =
      modifiedOptionsWithWieghtAndmaxWeight(updatedScores);

    dispatch(
      setWeight({
        type: "field",
        fieldId: item?.fieldId,
        scoreType: "byOptions",
        options: [...options],
        maxWeight: maxWeight,
      })
    );
  };

  useEffect(() => {
    if (!item?.options?.length) {
      const { options, maxWeight } =
        modifiedOptionsWithWieghtAndmaxWeight(scores);

      dispatch(
        setWeight({
          type: "field",
          fieldId: item?.fieldId,
          scoreType: "byOptions",
          options: [...options],
          maxWeight: maxWeight,
        })
      );
    }
  }, [item]);

  return (
    <div className={styles?.scoreContainer}>
      <div className={styles?.header}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Tooltip title={item?.name}>
            <span>{truncateText(item?.name || "", 50)}</span>
          </Tooltip>
          <Tooltip title={"Assign a value to each choice below."}>
            <InfoOutlinedIcon
              fontSize="small"
              sx={{ color: "#3e9ef7", cursor: "pointer" }}
            />
          </Tooltip>
        </div>
        <span
          style={{ cursor: "pointer" }}
          onClick={() => handleDelete(item.id, item?.fieldId)}
        >
          <HighlightOffOutlinedIcon
            sx={{ color: "#3e9ef7" }}
            fontSize="medium"
          />
        </span>
      </div>

      <div className={styles?.options}>
        <div>
          <InputLabel>Checked</InputLabel>
          <TextField
            size="small"
            type="number"
            value={scores.checked}
            onChange={(e) => handleInputChange("checked", e.target.value)}
            onBlur={(e) => !e.target.value && handleInputChange("checked", 0)}
          />
        </div>
        <div>
          <InputLabel>Not Checked</InputLabel>
          <TextField
            size="small"
            type="number"
            value={scores.unchecked}
            onChange={(e) => handleInputChange("unchecked", e.target.value)}
            onBlur={(e) => !e.target.value && handleInputChange("unchecked", 0)}
          />
        </div>
      </div>
    </div>
  );
};

export default CheckBoxScoreComponent;
